export enum AddEudrDdsDialogResponseEnum {
  GENERATE_NEW,
  ADD_EXISTING_DDS_IDENTIFIER,
  ADD_EXISTING_REFERENCE_NUMBER,
}
